/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Undo_DoneInputs */

const en_undo_done = /** @type {(inputs: Undo_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undone`)
};

/**
* | output |
* | --- |
* | "Undone" |
*
* @param {Undo_DoneInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const undo_done = /** @type {((inputs?: Undo_DoneInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Undo_DoneInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_undo_done(inputs)
});